import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Icon, notification, Menu, Dropdown } from "antd";
import axios from "axios";

import PlanoIranduba from "../EstabelecimentoPlano/PlanoIranduba";
import DrawerPlanoPEI from "../Drawers/DrawerPlanoPEI";
import DrawerPlanoPAEE from "../Drawers/DrawerPlanoPAEE";
import ModalPlanoAtendimentoPAEE from "../Modal/ModalPlanoAtendimentoPAEE";
import ModalPlanoAtendimentoPEI from "../Modal/ModalPlanoAtendimentoPEI";

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const PlanosIranduba = () => {
    const [planos, setPlanos] = useState([]);
    const [planoId, setPlanoId] = useState(null);
    const [drawerVisible, setDrawerVisible] = useState(false);
    const [drawerVisiblePEI, setDrawerVisiblePEI] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [modalVisiblePEI, setModalVisiblePEI] = useState(false);

    const [isLoading, setIsLoading] = useState(false);

    const montarBotaoVoltar = () => {
        if (localStorage.getItem("opcao_voltar") != null) {
            const opcaoInfo = JSON.parse(localStorage.getItem("opcao_voltar"));
            return (
                <>
                    <Link
                        to={opcaoInfo.link_voltar_curso ? opcaoInfo.link_voltar_curso : opcaoInfo.link_voltar}
                        className="botao-secundario botao-secundario-redondo"
                        onClick={() => opcaoInfo.id_curso && localStorage.setItem("codigo_curso", opcaoInfo.id_curso)}
                        style={{ marginRight: 10, display: "flex", justifyContent: "center", alignItems: "center" }}
                    >
                        <Icon type="arrow-left" />
                    </Link>
                </>
            );
        }
    };

    const handleEditarPlano = id => {
        setDrawerVisible(true);
        setPlanoId(id);
    };

    const handleEditarPlanoPEI = id => {
        setDrawerVisiblePEI(true);
        setPlanoId(id);
    };

    const handleViewPlano = id => {
        setModalVisible(true);
        setPlanoId(id);
    };

    const handleViewPlanoPEI = id => {
        setModalVisiblePEI(true);
        setPlanoId(id);
    };

    const handleCloseDrawer = () => {
        setDrawerVisible(false);
        setDrawerVisiblePEI(false);
        setPlanoId(null);
    };

    const handleCloseModal = () => {
        setModalVisible(false);
        setModalVisiblePEI(false);
        setPlanoId(null);
    };

    const carregarPlanos = () => {
        setIsLoading(true);

        axios({
            method: "get",
            url: "/api/plano-atendimento/carregar-planos-atendimento",
            params: {
                disciplinaId: localStorage.getItem("codigo_curso"),
                tipo: "paee"
            }
        })
            .then(response => {
                setPlanos(response.data);
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response?.data || "Ocorreu um erro ao carregar os planos.");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const atualizarListagem = () => {
        setDrawerVisible(false);
        setDrawerVisiblePEI(false);
        setPlanoId(null);
        carregarPlanos();
    };

    const handleDelete = () => {
        setModalVisible(false);
        setModalVisiblePEI(false);
        setPlanoId(null);
        carregarPlanos();
    };

    useEffect(() => {
        carregarPlanos();
    }, []);

    const menuAdicionar = (
        <Menu>
            <Menu.Item onClick={() => setDrawerVisible(true)}>Adicionar PAEE</Menu.Item>
            <Menu.Item onClick={() => setDrawerVisiblePEI(true)}>Adicionar PEI</Menu.Item>
        </Menu>
    );

    return (
        <>
            <div className="container container-body">
                <div className="turma-visao-geral">
                    <div className="controlos controlos-fundo ">
                        <div className="bloco-esquerda">
                            <span className="titulo-pagina">Planos de Atendimento</span>
                        </div>
                        <div className="bloco-direita">
                            <Dropdown overlay={menuAdicionar} placement="bottomLeft">
                                <Link to="#" className="botao-principal botao-principal-redondo" title="Novo atendimento">
                                    +
                                </Link>
                            </Dropdown>

                            {/* <Link
                                to="#"
                                className="botao-principal botao-principal-redondo"
                                title="Novo atendimento"
                                onClick={() => setDrawerVisible(true)}
                            >
                                +
                            </Link>
                            <Link
                                to="#"
                                className="botao-principal botao-principal-redondo"
                                title="Novo atendimento"
                                onClick={() => setDrawerVisiblePEI(true)}
                            >
                                *
                            </Link> */}
                            {montarBotaoVoltar()}
                        </div>
                    </div>
                    <div className="bloco">
                        <div className="bloco-atendimentos">
                            <div className="titulo-bloco-atendimentos">Planejamentos Criados</div>
                            <div className="lista-planos-atendimentos">
                                {planos.length === 0 && 'Nenhum plano criado ainda. Clique no botão " + " para criar seu primeiro plano.'}
                                {planos.map(plano => (
                                    <React.Fragment key={plano.id}>
                                        <PlanoIranduba
                                            onEdit={handleEditarPlano}
                                            onEditPEI={handleEditarPlanoPEI}
                                            onView={handleViewPlano}
                                            onViewPEI={handleViewPlanoPEI}
                                            plano={plano}
                                        />
                                    </React.Fragment>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <DrawerPlanoPEI id={planoId} visible={drawerVisiblePEI} onClose={handleCloseDrawer} atualizarListagem={atualizarListagem} />
            <DrawerPlanoPAEE id={planoId} visible={drawerVisible} onClose={handleCloseDrawer} atualizarListagem={atualizarListagem} />
            <ModalPlanoAtendimentoPAEE id={planoId} visible={modalVisible} onCancel={handleCloseModal} onDelete={handleDelete} />
            <ModalPlanoAtendimentoPEI id={planoId} visible={modalVisiblePEI} onCancel={handleCloseModal} onDelete={handleDelete} />
        </>
    );
};

export default PlanosIranduba;
